import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import usePageTracking from "./analytics/usePageTracking";
import "./App.css";
import "./styles/theme.css";
import Routing from "./routing";
import CookieConsentComponent from "./shared/components/CookieConsentComponent";
import ScrollToTopComponent from "./shared/components/ScrollToTopComponent";
import Footer from "./shared/layout/footer";
import Header from "./shared/layout/header";

function App() {
  const { pathname } = useLocation();

  usePageTracking();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Self-referencing canonical (kanonik alan adi: www'siz) — her route degisiminde
  useEffect(() => {
    const canonicalUrl = "https://securitasitfaiye.com" + pathname;
    let canonicalLink = document.querySelector(
      "link[rel='canonical']"
    ) as HTMLLinkElement | null;
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", canonicalUrl);
  }, [pathname]);

  return (
    <div className="it-app">
      <Header />
      <main>
        <ScrollToTopComponent />
        <CookieConsentComponent />
        <Routing />
      </main>
      <Footer />
    </div>
  );
}

export default App;
